import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 2000 } };

  connect() {
    this.timer = setInterval(() => this.#poll(), this.intervalValue);
  }

  disconnect() {
    clearInterval(this.timer);
  }

  #poll() {
    get(this.urlValue, { responseKind: "turbo-stream" });
  }
}
